/**
 * User registry and profile contracts (docs/adr/ADR-005, ADR-008). Managed by
 * administrators, who assign a profile (ruolo-modello) to each user and may set
 * exceptions for a single person.
 */
import { z } from 'zod';
import { accessSettingsSchema, normaliseProfileAccess, normaliseUserExceptions, } from './permissions.js';
import { emailSchema, idSchema, optionalText, requiredText } from './validation.js';
const userFields = {
    email: emailSchema,
    firstName: requiredText(100),
    lastName: requiredText(100),
    /** System administrators have every permission and manage users, profiles, backups and the activity log. */
    isAdmin: z.boolean(),
    /** Profile (ruolo-modello) of the user; null for access set only on the user. */
    profileId: idSchema.nullable().default(null),
    /** Exceptions to the profile, for this user only. */
    access: accessSettingsSchema.transform((settings) => normaliseUserExceptions(settings)),
};
/** Body of `POST /api/users`. */
export const createUserSchema = z.object(userFields);
/** Body of `PATCH /api/users/:id`: only the fields to change; `access` is replaced as a whole. */
export const updateUserSchema = z
    .object({ ...userFields, profileId: idSchema.nullable(), isActive: z.boolean() })
    .partial()
    .refine((body) => Object.keys(body).length > 0, { message: 'Nessuna modifica' });
const profileFields = {
    name: requiredText(100),
    description: optionalText(300),
    access: accessSettingsSchema.transform((settings) => normaliseProfileAccess(settings)),
};
/** Body of `POST /api/profiles`. */
export const createProfileSchema = z.object(profileFields);
/** Body of `PATCH /api/profiles/:id`: only the fields to change; `access` is replaced as a whole. */
export const updateProfileSchema = z
    .object(profileFields)
    .partial()
    .refine((body) => Object.keys(body).length > 0, { message: 'Nessuna modifica' });
//# sourceMappingURL=user-contracts.js.map